import React from 'react';
import { connect } from 'react-redux';
import ShortcutButton from '../shortcut-button/ShortcutButton';
import { goToStep, completeWizard, goToFollowUpCallStep } from './logActivityReducer';

@connect(
    state => ({}),
    { goToStep, completeWizard, goToFollowUpCallStep }
)
export default class WarnAgainstNoFergusAccountStep extends React.Component {
    bookMeeting() {
        this.props.goToStep('BookFollowUpOptionsStep');
    }
    render() {
        return(
            <div className="warn-step-wrapper">
                <h1>Customer has not setup Fergus account</h1>
                <p>Please advise customer to setup Fergus account</p>
                <div className="continue-wrapper">
                    <ShortcutButton shortcut="c" onClick={this.bookMeeting.bind(this)} type="primary">Continue</ShortcutButton>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./app/components/schedule-wizard/WarnAgainstNoFergusAccountStep.js